// Application configuration
const config = {
  // Enable/disable on-screen keyboard for touchscreen kiosks
  enableOnScreenKeyboard: true, // Set to false to disable

  // Enable kiosk mode for 1080x1920 displays
  kiosk: true, // Set to true for kiosk screens to apply larger, spread-out styling

  // API base URL - leave empty for relative URLs in production
  API_BASE_URL: '', // e.g., 'http://localhost:5444' for development

  // Other config options can be added here
};

export default config;
